import { Adapter } from "@/core/models/adapter";

/**
 * Product states
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/!**!/enums.json
 */
export const GRADE_A = "grade_a";
export const GRADE_B = "grade_b";
export const GRADE_C = "grade_c";
export const GRADE_D = "grade_d";
export const GRADE_E = "grade_e";

export const PRODUCT_STATES = [GRADE_A, GRADE_B, GRADE_C, GRADE_D, GRADE_E];

export const PRODUCT_CONDITIONS_ENUM = {
  grade_a: "Grade A",
  grade_b: "Grade B",
  grade_c: "Grade C",
  grade_d: "Grade D",
  grade_e: "Grade E",
};

export const PRODUCT_STATUS_DRAFT = "draft";
export const PRODUCT_STATUS_PUBLISHED = "published";
export const PRODUCT_GENERIC_REFERENCE = "CX_generic";
export const LENGTH_CODE_TAC = 8;

export class Product {
  constructor() {
    this.id = null;
    this.label = null;
    this.category = null;
    this.secondaryCategories = [];
    this.image = null;
    this.imageHd = null;
    this.eanCode = null;
    this.brand = null;
    this.status = null;
    this.priceGradeA = null;
    this.buybackPriceGradeA = null;
    this.buybackPriceGradeB = null;
    this.buybackPriceGradeC = null;
    this.buybackPriceGradeD = null;
    this.buybackPriceGradeE = null;
    this.comment = null;
    this.modele = null;
    this.reference = null;
    this.buybackZeroNotAllowed = false;
    this.effectiveWeight = null;
    this.effectiveLength = null;
    this.effectiveWidth = null;
    this.effectiveHeight = null;
    this.weight = null;
    this.length = null;
    this.width = null;
    this.height = null;
    this.isCollectingIMEI = false;
    this.tacCodes = [];
  }

  /**
   * @return {boolean}
   */
  isPublished() {
    return PRODUCT_STATUS_PUBLISHED === this.status;
  }
}

export class ProductAdapter extends Adapter {
  static adapt(itemApi) {
    const product = new Product();
    product.id = itemApi?.id;
    product.label = itemApi?.label;
    product.image = itemApi?.image;
    product.imageHd = itemApi?.imageHd;
    product.eanCode = itemApi?.eanCode;
    product.brand = itemApi?.brand;
    product.status = itemApi?.status;
    product.comment = itemApi?.comment;
    product.modele = itemApi?.modele;
    product.reference = itemApi?.reference;
    product.buybackPriceGradeA = itemApi?.buybackPriceGradeA;
    product.buybackPriceGradeB = itemApi?.buybackPriceGradeB;
    product.buybackPriceGradeC = itemApi?.buybackPriceGradeC;
    product.buybackPriceGradeD = itemApi?.buybackPriceGradeD;
    product.buybackPriceGradeE = itemApi?.buybackPriceGradeE;
    product.buybackZeroNotAllowed = itemApi?.buybackZeroNotAllowed;
    product.effectiveWeight = itemApi?.effectiveWeight;
    product.effectiveLength = itemApi?.effectiveLength;
    product.effectiveWidth = itemApi?.effectiveWidth;
    product.effectiveHeight = itemApi?.effectiveHeight;
    product.weight = itemApi?.weight;
    product.length = itemApi?.length;
    product.width = itemApi?.width;
    product.height = itemApi?.height;
    product.isCollectingIMEI = itemApi?.isCollectingIMEI ?? false;
    product.tacCodes = itemApi?.tacCodes ?? [];
    product.category = itemApi?.category;
    product.secondaryCategories = itemApi?.secondaryCategories ?? [];

    return product;
  }

  static adaptFromTypesense(itemTypesense) {
    const product = new Product();
    product.id = itemTypesense?.id;
    product.label = itemTypesense?.label;
    product.image = itemTypesense?.image;
    product.imageHd = itemTypesense?.imageHd;
    product.eanCode = itemTypesense?.eanCode;
    product.brand = itemTypesense?.brand;
    product.status = itemTypesense?.status;
    product.comment = itemTypesense?.comment;
    product.modele = itemTypesense?.modele;
    product.reference = itemTypesense?.reference;
    product.tacCodes = itemTypesense["imei.tacs"] ?? [];
    product.category = itemTypesense?.category;
    product.secondaryCategories = itemTypesense?.secondaryCategories ?? [];
    product.buybackPriceGradeA = itemTypesense?.price_grade_a;
    product.buybackZeroNotAllowed = itemTypesense?.buybackZeroNotAllowed;

    return product;
  }
}
